import React from 'react';
import SuppliersList from 'shared/components/ValueChain/Suppliers';
import ProcessingFacilityList from 'shared/components/ValueChain/ProcessingFacility';
import { TabsLabels, TabsKeys } from 'enums/ValueChainListEnums';
import clsx from 'clsx';
import styles from './ValueChainList.module.scss';
import { ReactComponent as ProcessingFacility } from 'assets/icons/factory_FILL0_wght400_GRAD0_opsz48 (1).svg';
import { ReactComponent as Suppliers } from 'assets/icons/supplier.svg';

interface getTabsProps {
  isActiveTab: (tab: string) => boolean;
  handleTabChange: (tab: string) => void;
}

export const getTabs = ({ isActiveTab, handleTabChange }: getTabsProps) => {
  return [
    {
      children: <ProcessingFacilityList />,
      active: isActiveTab(TabsKeys.PROCESSING_FACILITY),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.PROCESSING_FACILITY),
          })}
          onClick={() => handleTabChange(TabsKeys.PROCESSING_FACILITY)}>
          <ProcessingFacility
            className={clsx({
              [styles.iconDef]: true,
              [styles.icon]: isActiveTab(TabsKeys.PROCESSING_FACILITY),
            })}
          />
          {TabsLabels.PROCESSING_FACILITY}
        </span>
      ),
      key: TabsKeys.PROCESSING_FACILITY,
    },
    {
      children: <SuppliersList />,
      active: isActiveTab(TabsKeys.SUPPLIERS),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.SUPPLIERS),
          })}
          onClick={() => handleTabChange(TabsKeys.SUPPLIERS)}>
          <Suppliers
            className={clsx({
              [styles.icon]: isActiveTab(TabsKeys.SUPPLIERS),
            })}
          />
          {TabsLabels.SUPPLIERS}
        </span>
      ),
      key: TabsKeys.SUPPLIERS,
    },
  ];
};
